// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_cmp_editor = require("./MM_cmp_editor.res.js");
var MM_cmp_pe_index = require("../explorer/MM_cmp_pe_index.res.js");
var MM_cmp_settings = require("./MM_cmp_settings.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var MM_wrk_settings = require("../worker/MM_wrk_settings.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_UseTabs = require("../../rescript-utils/main/react-components/Expln_React_UseTabs.res.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");
var MM_wrk_pre_ctx_data = require("../worker/MM_wrk_pre_ctx_data.res.js");
var Styles = require("@mui/material/styles");
var MM_cmp_pe_frame_full = require("../explorer/MM_cmp_pe_frame_full.res.js");
var MM_cmp_context_selector = require("./MM_cmp_context_selector.res.js");
var Expln_React_ContentWithStickyHeader = require("../../rescript-utils/main/react-components/Expln_React_ContentWithStickyHeader.res.js");

function createInitialState(settings) {
  return {
          preCtxData: MM_wrk_pre_ctx_data.preCtxDataMake(settings),
          ctxSelectorIsExpanded: true
        };
}

function updatePreCtxData(st, settings, ctx) {
  return {
          preCtxData: MM_wrk_pre_ctx_data.preCtxDataUpdate(st.preCtxData, settings, ctx),
          ctxSelectorIsExpanded: st.ctxSelectorIsExpanded
        };
}

function updateCtxSelectorIsExpanded(st, ctxSelectorIsExpanded) {
  return {
          preCtxData: st.preCtxData,
          ctxSelectorIsExpanded: ctxSelectorIsExpanded
        };
}

var mainTheme = Styles.createTheme({
      palette: {
        white: {
          main: "#ffffff"
        },
        grey: {
          main: "#e0e0e0"
        },
        lightgrey: {
          main: "#e2e2e2"
        },
        red: {
          main: "#FF0000"
        },
        pastelred: {
          main: "#FAA0A0"
        },
        orange: {
          main: "#FF7900"
        },
        yellow: {
          main: "#FFE143"
        }
      }
    });

var $$location = window.location;

var tempMode = {
  contents: false
};

var initialStateSafeBase64 = new URLSearchParams($$location.search).get("editorState");

var editorInitialStateJsonStr = (initialStateSafeBase64 == null) ? Local_storage_utils.locStorReadString(MM_cmp_editor.editorStateLocStorKey) : (MM_react_common.removeQueryParamsFromUrl("removing editorState from the URL"), tempMode.contents = true, Common.safeBase64ToStr(initialStateSafeBase64));

if (tempMode.contents) {
  document.title = "TEMP " + document.title;
}

function MM_cmp_root(props) {
  var modalRef = Expln_React_Modal.useModalRef();
  var match = Expln_React_UseTabs.useTabs();
  var updateTabs = match.updateTabs;
  var activeTabId = match.activeTabId;
  var tabs = match.tabs;
  var removeTab = match.removeTab;
  var match$1 = React.useState(function () {
        return createInitialState(MM_cmp_settings.settingsReadFromLocStor());
      });
  var setState = match$1[1];
  var state = match$1[0];
  var match$2 = React.useState(function () {
        return true;
      });
  var setShowTabs = match$2[1];
  var showTabs = match$2[0];
  var reloadCtx = React.useRef(null);
  var addAsrtByLabel = React.useRef(null);
  var toggleCtxSelector = React.useRef(null);
  var loadEditorState = React.useRef(null);
  var isFrameExplorerTab = function (tabData, label) {
    if (typeof tabData !== "object") {
      return false;
    }
    if (tabData.TAG !== "ExplorerFrame") {
      return false;
    }
    var lbl = tabData.label;
    return Belt_Option.mapWithDefault(label, true, (function (label) {
                  return lbl === label;
                }));
  };
  var actCloseFrmTabs = function () {
    tabs.forEach(function (tab) {
          if (isFrameExplorerTab(tab.data, undefined)) {
            return removeTab(tab.id);
          }
          
        });
  };
  var actSettingsUpdated = function (newSettings) {
    actCloseFrmTabs();
    MM_cmp_settings.settingsSaveToLocStor(newSettings);
    setState(function (__x) {
          return updatePreCtxData(__x, newSettings, undefined);
        });
    if (state.preCtxData.settingsV.val.descrRegexToDisc !== newSettings.descrRegexToDisc || state.preCtxData.settingsV.val.labelRegexToDisc !== newSettings.labelRegexToDisc || state.preCtxData.settingsV.val.descrRegexToDepr !== newSettings.descrRegexToDepr || state.preCtxData.settingsV.val.labelRegexToDepr !== newSettings.labelRegexToDepr) {
      return Belt_Option.forEach(Caml_option.nullable_to_opt(reloadCtx.current), (function (reloadCtx) {
                    reloadCtx(state.preCtxData.srcs, newSettings, true, true);
                  }));
    }
    
  };
  var actCtxSelectorExpandedChange = function (expanded) {
    setState(function (__x) {
          return updateCtxSelectorIsExpanded(__x, expanded);
        });
  };
  var openFrameExplorer = function (label) {
    setState(function (st) {
          var match = MM_context.getFrame(st.preCtxData.ctxV.val, label);
          if (match !== undefined) {
            updateTabs(function (tabsSt) {
                  var tab = Expln_React_UseTabs.getTabs(tabsSt).find(function (tab) {
                        return isFrameExplorerTab(tab.data, label);
                      });
                  if (tab !== undefined) {
                    return Expln_React_UseTabs.openTab(tabsSt, tab.id);
                  } else {
                    return Expln_React_UseTabs.addTab(tabsSt, label, true, undefined, {
                                  TAG: "ExplorerFrame",
                                  label: label
                                }, true)[0];
                  }
                });
          } else {
            MM_react_common.openInfoDialog(modalRef, "Cannot find an assertion by label '" + label + "'", undefined, undefined, undefined, undefined);
          }
          return st;
        });
  };
  var openExplorer = function (initPatternFilterStr) {
    updateTabs(function (tabsSt) {
          return Expln_React_UseTabs.addTab(tabsSt, "EXPLORER " + initPatternFilterStr.substring(0, 40), true, undefined, {
                        TAG: "ExplorerIndex",
                        initPatternFilterStr: initPatternFilterStr
                      }, true)[0];
        });
  };
  var focusEditorTab = function () {
    updateTabs(function (tabsSt) {
          var tab = Expln_React_UseTabs.getTabs(tabsSt).find(function (tab) {
                var tabData = tab.data;
                if (typeof tabData !== "object" && tabData === "Editor") {
                  return true;
                } else {
                  return false;
                }
              });
          if (tab !== undefined) {
            return Expln_React_UseTabs.openTab(tabsSt, tab.id);
          } else {
            return tabsSt;
          }
        });
  };
  React.useEffect((function () {
          updateTabs(function (st) {
                if (Expln_React_UseTabs.getTabs(st).length !== 0) {
                  return st;
                }
                var match = Expln_React_UseTabs.addTab(st, "Settings", false, undefined, "Settings", undefined);
                var match$1 = Expln_React_UseTabs.addTab(match[0], "Editor", false, tempMode.contents ? "orange" : undefined, "Editor", true);
                return Expln_React_UseTabs.addTab(match$1[0], "Explorer", false, undefined, {
                              TAG: "ExplorerIndex",
                              initPatternFilterStr: ""
                            }, undefined)[0];
              });
        }), []);
  var tmp = {};
  var tmp$1 = state.preCtxData.settingsV.val.hideContextSelector && !state.ctxSelectorIsExpanded ? "none" : undefined;
  if (tmp$1 !== undefined) {
    tmp.display = tmp$1;
  }
  return React.createElement(Styles.ThemeProvider, {
              theme: mainTheme,
              children: React.createElement(Expln_React_ContentWithStickyHeader.make, {
                    top: 0,
                    header: React.createElement(Expln_React_Column.make, {
                          children: Caml_option.some(null)
                        }, React.createElement(MM_cmp_context_selector.make, {
                              modalRef: modalRef,
                              settings: state.preCtxData.settingsV.val,
                              onUrlBecomesTrusted: (function (url) {
                                  actSettingsUpdated(MM_wrk_settings.markUrlAsTrusted(state.preCtxData.settingsV.val, url));
                                }),
                              onChange: (function (srcs, ctx) {
                                  actCloseFrmTabs();
                                  setState(function (__x) {
                                        return updatePreCtxData(__x, undefined, [
                                                    srcs,
                                                    ctx
                                                  ]);
                                      });
                                }),
                              reloadCtx: reloadCtx,
                              style: tmp,
                              onExpandedChange: actCtxSelectorExpandedChange,
                              doToggle: toggleCtxSelector
                            }), showTabs ? match.renderTabs() : React.createElement("div", {
                                style: {
                                  display: "none"
                                }
                              })),
                    content: (function (contentTop) {
                        return React.createElement(Expln_React_Column.make, {
                                    children: Caml_option.some(null)
                                  }, tabs.map(function (__x) {
                                        var match = __x.data;
                                        var tmp;
                                        tmp = typeof match !== "object" ? (
                                            match === "Settings" ? React.createElement(MM_cmp_settings.make, {
                                                    modalRef: modalRef,
                                                    preCtxData: state.preCtxData,
                                                    onChange: actSettingsUpdated
                                                  }) : React.createElement(MM_cmp_editor.make, {
                                                    modalRef: modalRef,
                                                    preCtxData: state.preCtxData,
                                                    top: contentTop,
                                                    reloadCtx: reloadCtx,
                                                    addAsrtByLabel: addAsrtByLabel,
                                                    loadEditorState: loadEditorState,
                                                    initialStateJsonStr: editorInitialStateJsonStr,
                                                    tempMode: tempMode.contents,
                                                    toggleCtxSelector: toggleCtxSelector,
                                                    ctxSelectorIsExpanded: state.ctxSelectorIsExpanded,
                                                    showTabs: showTabs,
                                                    setShowTabs: (function (b) {
                                                        setShowTabs(function (param) {
                                                              return b;
                                                            });
                                                      }),
                                                    openFrameExplorer: openFrameExplorer
                                                  })
                                          ) : (
                                            match.TAG === "ExplorerIndex" ? React.createElement(MM_cmp_pe_index.make, {
                                                    modalRef: modalRef,
                                                    preCtxData: state.preCtxData,
                                                    openFrameExplorer: openFrameExplorer,
                                                    openExplorer: openExplorer,
                                                    toggleCtxSelector: toggleCtxSelector,
                                                    ctxSelectorIsExpanded: state.ctxSelectorIsExpanded,
                                                    initPatternFilterStr: match.initPatternFilterStr,
                                                    addAsrtByLabel: addAsrtByLabel
                                                  }) : React.createElement(MM_cmp_pe_frame_full.make, {
                                                    top: contentTop,
                                                    modalRef: modalRef,
                                                    preCtxData: state.preCtxData,
                                                    label: match.label,
                                                    openFrameExplorer: openFrameExplorer,
                                                    openExplorer: openExplorer,
                                                    loadEditorState: loadEditorState,
                                                    focusEditorTab: focusEditorTab,
                                                    toggleCtxSelector: toggleCtxSelector,
                                                    ctxSelectorIsExpanded: state.ctxSelectorIsExpanded
                                                  })
                                          );
                                        return React.createElement("div", {
                                                    key: __x.id,
                                                    style: {
                                                      display: __x.id === activeTabId ? "block" : "none"
                                                    }
                                                  }, tmp);
                                      }), React.createElement(Expln_React_Modal.make, {
                                        modalRef: modalRef
                                      }));
                      })
                  })
            });
}

var make = MM_cmp_root;

exports.createInitialState = createInitialState;
exports.updatePreCtxData = updatePreCtxData;
exports.updateCtxSelectorIsExpanded = updateCtxSelectorIsExpanded;
exports.mainTheme = mainTheme;
exports.$$location = $$location;
exports.tempMode = tempMode;
exports.editorInitialStateJsonStr = editorInitialStateJsonStr;
exports.make = make;
/* mainTheme Not a pure module */
